import React from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import classNames from 'classnames';
import { FormatDateFull } from 'helpers/FormatData.js';
import PropTypes from 'prop-types';
import IconButton from 'componentes/common/IconButton.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const QuejaSeguimiento = ({
  setOpenModal,
  isOpen,
  setOpenModalEdit,
  quejaSeguimiento
}) => {
  return (
    <Card>
      <Card.Header>
        <Row className="g-2">
          <Col>
            <h5 className="mb-0">Audiencias y seguimiento</h5>
          </Col>
          <Col xs="auto">
            {isOpen && (
              <IconButton
                iconClassName="fs-11 me-1"
                variant="falcon-default"
                size="sm"
                icon="pencil-alt"
                onClick={() => setOpenModal(true)}
              >
                Agendar Audiencia
              </IconButton>
            )}
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="border-top p-0">
        <Row key={0} className="bg-200 m-1 text-nowrap align-middle center">
          <Col md={2} className="fs-10 m-2">
            <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">Tipo</h5>
          </Col>
          <Col md={3} className="fs-10 m-2">
            <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">Fecha</h5>
          </Col>
          <Col md="auto" className="fs-10 m-2" style={{ minWidth: '250px' }}>
            <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">Notas</h5>
          </Col>
          <Col></Col>
        </Row>
        {quejaSeguimiento &&
          quejaSeguimiento
            .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
            .map(log => (
              <Row
                key={log.idseguimientoqueja}
                className="g-0 align-items-center border-bottom py-2 px-3"
              >
                <Col md={2} className="pe-3">
                  <span
                    className={classNames('badge rounded-pill', {
                      'badge-subtle-success': !log.espresencial,
                      'badge-subtle-warning': log.espresencial
                    })}
                  >
                    {log.espresencial ? 'Presencial' : 'Virtual'}
                  </span>
                </Col>
                <Col md={3} className="mt-1 mt-md-0">
                  <code>{FormatDateFull(log.fecha)}</code>
                </Col>
                <Col md="auto" style={{ minWidth: '250px' }}>
                  <p className="mb-0">{log.notas || '-'}</p>
                </Col>
                <Col md="auto">
                  {/* <Button
                    variant="falcon-default"
                    size="sm"
                    title="Agregar Nota"
                    onClick={() => {
                      
                      setOpenModalComment(true);
                    }}
                  >
                    <FontAwesomeIcon icon="comment" />
                  </Button> */}
                  {isOpen && (
                    <Button
                      variant="falcon-default"
                      size="sm"
                      title="Reagendar Audiencia"
                      onClick={() => {
                        setOpenModalEdit({
                          idSeguimiento: log.idseguimientoqueja,
                          currentDate: new Date(log.fecha)
                        });
                      }}
                    >
                      <FontAwesomeIcon icon="clock" />
                    </Button>
                  )}
                </Col>
              </Row>
            ))}
      </Card.Body>
      <Card.Footer className="border-top text-end">
        {/* <IconButton
                iconClassName="fs-11 me-1"
                variant="falcon-default"
                size="sm"
                icon="dollar-sign"
              >
                Refund
              </IconButton>
              <IconButton
                className="ms-2"
                iconClassName="fs-11 me-1"
                variant="falcon-default"
                size="sm"
                icon="check"
              >
                Save changes
              </IconButton> */}
      </Card.Footer>
    </Card>
  );
};
QuejaSeguimiento.propTypes = {
  setOpenModal: PropTypes.func,
  isOpen: PropTypes.bool,
  setOpenModalEdit: PropTypes.func,
  quejaSeguimiento: PropTypes.array
};
export default QuejaSeguimiento;
